import moment from 'moment';

import { Formats } from './constants';

const format = {
  date(value, isEditable = true) {
    if (!isEditable) {
      return value ? moment(value, Formats, true).format('YYYY-MM-DD') : value;
    }

    if (value === null) {
      return '';
    }

    if (!moment(value, Formats, true).isValid()) {
      return value;
    }

    return moment(value, Formats, true).format('YYYY-MM-DD');
  },
};

export default format;
